export enum ProductionZone {
  SELF = 'myProduction',
  GROUP = 'grupoProduction',
  COMMUNITY = 'comunidadeProduction',
}

export function getProductionZoneLabel({
  productionZone,
  isShort,
}: {
  productionZone: ProductionZone;
  isShort?: boolean;
}): string {
  if (isShort) {
    switch (productionZone) {
      case ProductionZone.SELF:
        return 'Sua produção';
      case ProductionZone.GROUP:
        return 'Grupo';
      case ProductionZone.COMMUNITY:
        return 'Comunidade';
    }
  }

  switch (productionZone) {
    case ProductionZone.SELF:
      return 'Sua produção';
    case ProductionZone.GROUP:
      return 'Produção do grupo';
    case ProductionZone.COMMUNITY:
      return 'Produção da comunidade';
  }
}
